globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalCreateContact = (function(superClass)
{
    utils.extend(ModalCreateContact, superClass);

    function ModalCreateContact($html) {
      return ModalCreateContact.__super__.constructor.apply(this, arguments);
    }

    $.extend(ModalCreateContact.prototype, {
      init: function()
      {
        $(".styled").uniform({
            radioClass: 'choice'
        });

        ModalCreateContact.__super__.init.apply(this, arguments);
      },
      callbackSuccess: function(data) {
        if(data.response) {
          location.reload();
        }

        ModalCreateContact.__super__.callbackSuccess.apply(this, arguments);
      }
    });

    return ModalCreateContact;
})(backoffice.ModalMain);
